export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-tags.vue?vue&type=template&id=70be4f61&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-tags/lk-tags.vue?vue&type=template&id=70be4f61&
// module id = 1413
// module chunks = 0